
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';

// User routes imports
import Home from './routes/Home';
import About from './routes/About';
import Service from './routes/Service';
import Contact from './routes/Contact';
import PCTC from './routes/PCTC';
import PCTC2 from './routes/PCTC2';
import IntraAsia from './routes/IntraAsia';
import BayBengal from './routes/BayBengal';
import Terms from './routes/Terms';
import Privacy from './routes/Privacy';

// User components imports
import Video from './components/Video';
import Video2 from './components/Video2';

// Admin components imports
import Login from './adminwork/Login';
import AdminDashboard from './adminwork/AdminDashboard';
import AdminNavbar from './adminwork/AdminNavbar';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
  
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <>
      <div className="App">
        <Routes>
          {/* User Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/pctc" element={<PCTC />} />
          <Route path="/pctc2" element={<PCTC2 />} />
          <Route path="/intra-asia" element={<IntraAsia />} />
          <Route path="/Bay-of-Bengal" element={<BayBengal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/video" element={<Video />} />
          <Route path="/video2" element={<Video2 />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />

          {/* Admin Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Admin Routes */}
          <Route path="/admindashboard" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/adminnavbar" element={
            <ProtectedRoute>
              <AdminNavbar />
            </ProtectedRoute>
          } />
          
          {/* Redirect unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </>
  );
}

export default App;